import { baseApiClient as api } from "../baseService";

export const addTagTypes = [
  "record-request-hipaa-authorizations",
  "record-requests",
  "record-request-audit-logs",
  "record-request-channels",
  "record-request-invoices",
  "treatment_requests",
  "record-request-records",
] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      mattersHipaaAuthorizationCreate: build.mutation<
        MattersHipaaAuthorizationCreateApiResponse,
        MattersHipaaAuthorizationCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/`,
          method: "POST",
          body: queryArg.createTreatmentRecordRequestHipaaAuthorizationSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationUpdate: build.mutation<
        MattersHipaaAuthorizationUpdateApiResponse,
        MattersHipaaAuthorizationUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/${queryArg.authorizationId}/`,
          method: "PUT",
          body: queryArg.updateTreatmentRecordRequestHipaaAuthorizationSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationDestroy: build.mutation<
        MattersHipaaAuthorizationDestroyApiResponse,
        MattersHipaaAuthorizationDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/${queryArg.authorizationId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationForMatterRetrieve: build.query<
        MattersHipaaAuthorizationForMatterRetrieveApiResponse,
        MattersHipaaAuthorizationForMatterRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/for-matter/`,
        }),
        providesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationRefreshCreate: build.mutation<
        MattersHipaaAuthorizationRefreshCreateApiResponse,
        MattersHipaaAuthorizationRefreshCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/refresh/`,
          method: "POST",
          body: queryArg.hipaaAuthorizationDocumentReferenceSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationRemindCreate: build.mutation<
        MattersHipaaAuthorizationRemindCreateApiResponse,
        MattersHipaaAuthorizationRemindCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/remind/`,
          method: "POST",
          body: queryArg.hipaaAuthorizationReminderSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationSendCreate: build.mutation<
        MattersHipaaAuthorizationSendCreateApiResponse,
        MattersHipaaAuthorizationSendCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/send/`,
          method: "POST",
          body: queryArg.hipaaAuthorizationSendSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersHipaaAuthorizationStatusRetrieve: build.query<
        MattersHipaaAuthorizationStatusRetrieveApiResponse,
        MattersHipaaAuthorizationStatusRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/status/`,
        }),
        providesTags: ["record-request-hipaa-authorizations"],
      }),
      voidHipaaAuthorization: build.mutation<
        VoidHipaaAuthorizationApiResponse,
        VoidHipaaAuthorizationApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/hipaa-authorization/void/`,
          method: "POST",
          body: queryArg.hipaaAuthorizationVoidSchema,
        }),
        invalidatesTags: ["record-request-hipaa-authorizations"],
      }),
      mattersProvidersRecordRequestsList: build.query<
        MattersProvidersRecordRequestsListApiResponse,
        MattersProvidersRecordRequestsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/`,
        }),
        providesTags: ["record-requests"],
      }),
      mattersProvidersRecordRequestsCreate: build.mutation<
        MattersProvidersRecordRequestsCreateApiResponse,
        MattersProvidersRecordRequestsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/`,
          method: "POST",
          body: queryArg.createTreatmentRecordRequestSchema,
        }),
        invalidatesTags: ["record-requests"],
      }),
      mattersProvidersRecordRequestsRetrieve: build.query<
        MattersProvidersRecordRequestsRetrieveApiResponse,
        MattersProvidersRecordRequestsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/`,
        }),
        providesTags: ["record-requests"],
      }),
      mattersProvidersRecordRequestsUpdate: build.mutation<
        MattersProvidersRecordRequestsUpdateApiResponse,
        MattersProvidersRecordRequestsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/`,
          method: "PUT",
          body: queryArg.updateTreatmentRecordRequestSchema,
        }),
        invalidatesTags: ["record-requests"],
      }),
      mattersProvidersRecordRequestsDestroy: build.mutation<
        MattersProvidersRecordRequestsDestroyApiResponse,
        MattersProvidersRecordRequestsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["record-requests"],
      }),
      acceptAlternateContact: build.mutation<
        AcceptAlternateContactApiResponse,
        AcceptAlternateContactApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/accept-alternate/`,
          method: "POST",
          body: queryArg.acceptAlternateContactSchema,
        }),
        invalidatesTags: ["record-requests"],
      }),
      mattersProvidersRecordRequestsAuditLogsList: build.query<
        MattersProvidersRecordRequestsAuditLogsListApiResponse,
        MattersProvidersRecordRequestsAuditLogsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/audit-logs/`,
        }),
        providesTags: ["record-request-audit-logs"],
      }),
      mattersProvidersRecordRequestsAuditLogsCreate: build.mutation<
        MattersProvidersRecordRequestsAuditLogsCreateApiResponse,
        MattersProvidersRecordRequestsAuditLogsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/audit-logs/`,
          method: "POST",
          body: queryArg.createTreatmentRecordRequestAuditLogSchema,
        }),
        invalidatesTags: ["record-request-audit-logs"],
      }),
      mattersProvidersRecordRequestsAuditLogsRetrieve: build.query<
        MattersProvidersRecordRequestsAuditLogsRetrieveApiResponse,
        MattersProvidersRecordRequestsAuditLogsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/audit-logs/${queryArg.logId}/`,
        }),
        providesTags: ["record-request-audit-logs"],
      }),
      mattersProvidersRecordRequestsAuditLogsUpdate: build.mutation<
        MattersProvidersRecordRequestsAuditLogsUpdateApiResponse,
        MattersProvidersRecordRequestsAuditLogsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/audit-logs/${queryArg.logId}/`,
          method: "PUT",
          body: queryArg.updateTreatmentRecordRequestAuditLogSchema,
        }),
        invalidatesTags: ["record-request-audit-logs"],
      }),
      mattersProvidersRecordRequestsAuditLogsDestroy: build.mutation<
        MattersProvidersRecordRequestsAuditLogsDestroyApiResponse,
        MattersProvidersRecordRequestsAuditLogsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/audit-logs/${queryArg.logId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["record-request-audit-logs"],
      }),
      mattersProvidersRecordRequestsChangeStatusCreate: build.mutation<
        MattersProvidersRecordRequestsChangeStatusCreateApiResponse,
        MattersProvidersRecordRequestsChangeStatusCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/change_status/`,
          method: "POST",
          body: queryArg.changeTreatmentRecordRequestStatusSchema,
        }),
        invalidatesTags: ["record-requests"],
      }),
      mattersProvidersRecordRequestsChannelsList: build.query<
        MattersProvidersRecordRequestsChannelsListApiResponse,
        MattersProvidersRecordRequestsChannelsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/channels/`,
        }),
        providesTags: ["record-request-channels"],
      }),
      mattersProvidersRecordRequestsChannelsCreate: build.mutation<
        MattersProvidersRecordRequestsChannelsCreateApiResponse,
        MattersProvidersRecordRequestsChannelsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/channels/`,
          method: "POST",
          body: queryArg.createTreatmentRecordRequestChannelSchema,
        }),
        invalidatesTags: ["record-request-channels"],
      }),
      mattersProvidersRecordRequestsChannelsRetrieve: build.query<
        MattersProvidersRecordRequestsChannelsRetrieveApiResponse,
        MattersProvidersRecordRequestsChannelsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/channels/${queryArg.channelId}/`,
        }),
        providesTags: ["record-request-channels"],
      }),
      mattersProvidersRecordRequestsChannelsUpdate: build.mutation<
        MattersProvidersRecordRequestsChannelsUpdateApiResponse,
        MattersProvidersRecordRequestsChannelsUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/channels/${queryArg.channelId}/`,
          method: "PUT",
          body: queryArg.updateTreatmentRecordRequestChannelSchema,
        }),
        invalidatesTags: ["record-request-channels"],
      }),
      mattersProvidersRecordRequestsChannelsDestroy: build.mutation<
        MattersProvidersRecordRequestsChannelsDestroyApiResponse,
        MattersProvidersRecordRequestsChannelsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/channels/${queryArg.channelId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["record-request-channels"],
      }),
      getFollowupHistory: build.query<
        GetFollowupHistoryApiResponse,
        GetFollowupHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/followup-history/`,
        }),
        providesTags: ["record-requests"],
      }),
      getFollowupOutcome: build.query<
        GetFollowupOutcomeApiResponse,
        GetFollowupOutcomeApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/followup-outcome/`,
        }),
        providesTags: ["record-requests"],
      }),
      getHipaaEmailTemplate: build.query<
        GetHipaaEmailTemplateApiResponse,
        GetHipaaEmailTemplateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/hipaa-email-template/`,
          params: {
            cover_page_from: queryArg.coverPageFrom,
            cover_page_message: queryArg.coverPageMessage,
            cover_page_to: queryArg.coverPageTo,
          },
        }),
        providesTags: ["record-requests"],
      }),
      getHipaaSubmissionStatus: build.query<
        GetHipaaSubmissionStatusApiResponse,
        GetHipaaSubmissionStatusApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/hipaa-submission-status/`,
        }),
        providesTags: ["record-requests"],
      }),
      mattersProvidersRecordRequestsInvoicesList: build.query<
        MattersProvidersRecordRequestsInvoicesListApiResponse,
        MattersProvidersRecordRequestsInvoicesListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/invoices/`,
        }),
        providesTags: ["record-request-invoices"],
      }),
      mattersProvidersRecordRequestsInvoicesCreate: build.mutation<
        MattersProvidersRecordRequestsInvoicesCreateApiResponse,
        MattersProvidersRecordRequestsInvoicesCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/invoices/`,
          method: "POST",
          body: queryArg.createTreatmentRecordRequestInvoiceSchema,
        }),
        invalidatesTags: ["record-request-invoices"],
      }),
      mattersProvidersRecordRequestsInvoicesRetrieve: build.query<
        MattersProvidersRecordRequestsInvoicesRetrieveApiResponse,
        MattersProvidersRecordRequestsInvoicesRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/invoices/${queryArg.invoiceId}/`,
        }),
        providesTags: ["record-request-invoices"],
      }),
      mattersProvidersRecordRequestsInvoicesUpdate: build.mutation<
        MattersProvidersRecordRequestsInvoicesUpdateApiResponse,
        MattersProvidersRecordRequestsInvoicesUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/invoices/${queryArg.invoiceId}/`,
          method: "PUT",
        }),
        invalidatesTags: ["record-request-invoices"],
      }),
      requestHipaaPackageRetrieve: build.query<
        RequestHipaaPackageRetrieveApiResponse,
        RequestHipaaPackageRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/`,
        }),
        providesTags: ["treatment_requests"],
      }),
      requestPackageComponentList: build.query<
        RequestPackageComponentListApiResponse,
        RequestPackageComponentListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/`,
        }),
        providesTags: ["treatment_requests"],
      }),
      requestPackageComponentCreate: build.mutation<
        RequestPackageComponentCreateApiResponse,
        RequestPackageComponentCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/`,
          method: "POST",
          body: queryArg.createPackageComponent,
        }),
        invalidatesTags: ["treatment_requests"],
      }),
      requestPackageComponentRetrieve: build.query<
        RequestPackageComponentRetrieveApiResponse,
        RequestPackageComponentRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/${queryArg.id}/`,
        }),
        providesTags: ["treatment_requests"],
      }),
      requestPackageComponentUpdate: build.mutation<
        RequestPackageComponentUpdateApiResponse,
        RequestPackageComponentUpdateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/${queryArg.id}/`,
          method: "PATCH",
          body: queryArg.patchedUpdatePackageComponent,
        }),
        invalidatesTags: ["treatment_requests"],
      }),
      requestPackageComponentDelete: build.mutation<
        RequestPackageComponentDeleteApiResponse,
        RequestPackageComponentDeleteApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/${queryArg.id}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["treatment_requests"],
      }),
      requestPackageComponentReorder: build.mutation<
        RequestPackageComponentReorderApiResponse,
        RequestPackageComponentReorderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/reorder/`,
          method: "POST",
          body: queryArg.reorderComponentsRequest,
        }),
        invalidatesTags: ["treatment_requests"],
      }),
      requestPackageComponentSearchTemplates: build.query<
        RequestPackageComponentSearchTemplatesApiResponse,
        RequestPackageComponentSearchTemplatesApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/search_templates/`,
          params: {
            category: queryArg.category,
            include_global: queryArg.includeGlobal,
            search: queryArg.search,
          },
        }),
        providesTags: ["treatment_requests"],
      }),
      requestPackageComponentValidateAll: build.mutation<
        RequestPackageComponentValidateAllApiResponse,
        RequestPackageComponentValidateAllApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.packageId}/components/validate_all/`,
          method: "POST",
        }),
        invalidatesTags: ["treatment_requests"],
      }),
      requestHipaaPackageRetrieve2: build.query<
        RequestHipaaPackageRetrieve2ApiResponse,
        RequestHipaaPackageRetrieve2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.id}/`,
        }),
        providesTags: ["treatment_requests"],
      }),
      requestHipaaPackageCreateWithDefaults: build.mutation<
        RequestHipaaPackageCreateWithDefaultsApiResponse,
        RequestHipaaPackageCreateWithDefaultsApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/${queryArg.id}/create_with_defaults/`,
          method: "POST",
        }),
        invalidatesTags: ["treatment_requests"],
      }),
      requestHipaaPackagePublish: build.mutation<
        RequestHipaaPackagePublishApiResponse,
        RequestHipaaPackagePublishApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/publish/`,
          method: "POST",
        }),
        invalidatesTags: ["treatment_requests"],
      }),
      requestHipaaPackageRender: build.mutation<
        RequestHipaaPackageRenderApiResponse,
        RequestHipaaPackageRenderApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/render/`,
          method: "POST",
        }),
        invalidatesTags: ["treatment_requests"],
      }),
      requestHipaaPackageUpload: build.mutation<
        RequestHipaaPackageUploadApiResponse,
        RequestHipaaPackageUploadApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/package/upload/`,
          method: "POST",
          body: queryArg.body,
        }),
        invalidatesTags: ["treatment_requests"],
      }),
      mattersProvidersRecordRequestsRecordsList: build.query<
        MattersProvidersRecordRequestsRecordsListApiResponse,
        MattersProvidersRecordRequestsRecordsListApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/records/`,
        }),
        providesTags: ["record-request-records"],
      }),
      mattersProvidersRecordRequestsRecordsCreate: build.mutation<
        MattersProvidersRecordRequestsRecordsCreateApiResponse,
        MattersProvidersRecordRequestsRecordsCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/records/`,
          method: "POST",
          body: queryArg.createTreatmentRecordRequestRecordSchema,
        }),
        invalidatesTags: ["record-request-records"],
      }),
      mattersProvidersRecordRequestsRecordsRetrieve: build.query<
        MattersProvidersRecordRequestsRecordsRetrieveApiResponse,
        MattersProvidersRecordRequestsRecordsRetrieveApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/records/${queryArg.recordId}/`,
        }),
        providesTags: ["record-request-records"],
      }),
      mattersProvidersRecordRequestsRecordsDestroy: build.mutation<
        MattersProvidersRecordRequestsRecordsDestroyApiResponse,
        MattersProvidersRecordRequestsRecordsDestroyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/records/${queryArg.recordId}/`,
          method: "DELETE",
        }),
        invalidatesTags: ["record-request-records"],
      }),
      resendRecordRequest: build.mutation<
        ResendRecordRequestApiResponse,
        ResendRecordRequestApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/resend/`,
          method: "POST",
          body: queryArg.resendTreatmentRecordRequestSchema,
        }),
        invalidatesTags: ["record-requests"],
      }),
      retryExistingContact: build.mutation<
        RetryExistingContactApiResponse,
        RetryExistingContactApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/retry-existing/`,
          method: "POST",
          body: queryArg.retryTreatmentRecordRequestSchema,
        }),
        invalidatesTags: ["record-requests"],
      }),
      sendFollowupTransmission: build.mutation<
        SendFollowupTransmissionApiResponse,
        SendFollowupTransmissionApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/send-followup/`,
          method: "POST",
          body: queryArg.sendFollowupSchema,
        }),
        invalidatesTags: ["record-requests"],
      }),
      mattersProvidersRecordRequestsSendBlandCallCreate: build.mutation<
        MattersProvidersRecordRequestsSendBlandCallCreateApiResponse,
        MattersProvidersRecordRequestsSendBlandCallCreateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/send_bland_call/`,
          method: "POST",
          body: queryArg.voiceAiCallArgs,
        }),
        invalidatesTags: ["record-requests"],
      }),
      submitHipaaPackage: build.mutation<
        SubmitHipaaPackageApiResponse,
        SubmitHipaaPackageApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/submit_hipaa_package/`,
          method: "POST",
          body: queryArg.submitHipaaPackageSchema,
        }),
        invalidatesTags: ["record-requests"],
      }),
      transmissionStrategy: build.query<
        TransmissionStrategyApiResponse,
        TransmissionStrategyApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/transmission-strategy/`,
        }),
        providesTags: ["record-requests"],
      }),
      transmissionStrategy2: build.mutation<
        TransmissionStrategy2ApiResponse,
        TransmissionStrategy2ApiArg
      >({
        query: (queryArg) => ({
          url: `/api/matters/${queryArg.matterId}/providers/${queryArg.providerId}/record-requests/${queryArg.requestId}/transmission-strategy/`,
          method: "POST",
          body: queryArg.transmissionStrategySchema,
        }),
        invalidatesTags: ["record-requests"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as enhancedApi };
export type MattersHipaaAuthorizationCreateApiResponse =
  /** status 201  */ TreatmentRecordRequestHipaaAuthorizationSchema;
export type MattersHipaaAuthorizationCreateApiArg = {
  matterId: string;
  createTreatmentRecordRequestHipaaAuthorizationSchema: CreateTreatmentRecordRequestHipaaAuthorizationSchema;
};
export type MattersHipaaAuthorizationUpdateApiResponse =
  /** status 200  */ TreatmentRecordRequestHipaaAuthorizationSchema;
export type MattersHipaaAuthorizationUpdateApiArg = {
  authorizationId: string;
  matterId: string;
  updateTreatmentRecordRequestHipaaAuthorizationSchema: UpdateTreatmentRecordRequestHipaaAuthorizationSchema;
};
export type MattersHipaaAuthorizationDestroyApiResponse = unknown;
export type MattersHipaaAuthorizationDestroyApiArg = {
  authorizationId: string;
  matterId: string;
};
export type MattersHipaaAuthorizationForMatterRetrieveApiResponse =
  /** status 200  */ TreatmentRecordRequestHipaaAuthorizationSchema;
export type MattersHipaaAuthorizationForMatterRetrieveApiArg = {
  matterId: string;
};
export type MattersHipaaAuthorizationRefreshCreateApiResponse =
  /** status 200  */ DocumentInstanceRead;
export type MattersHipaaAuthorizationRefreshCreateApiArg = {
  matterId: string;
  hipaaAuthorizationDocumentReferenceSchema: HipaaAuthorizationDocumentReferenceSchema;
};
export type MattersHipaaAuthorizationRemindCreateApiResponse =
  /** status 200  */ DocumentInstanceRead;
export type MattersHipaaAuthorizationRemindCreateApiArg = {
  matterId: string;
  hipaaAuthorizationReminderSchema: HipaaAuthorizationReminderSchema;
};
export type MattersHipaaAuthorizationSendCreateApiResponse =
  /** status 201  */ DocumentInstanceRead;
export type MattersHipaaAuthorizationSendCreateApiArg = {
  matterId: string;
  hipaaAuthorizationSendSchema: HipaaAuthorizationSendSchema;
};
export type MattersHipaaAuthorizationStatusRetrieveApiResponse =
  /** status 200  */ DocumentInstanceRead;
export type MattersHipaaAuthorizationStatusRetrieveApiArg = {
  matterId: string;
};
export type VoidHipaaAuthorizationApiResponse =
  /** status 200  */ DocumentInstanceRead;
export type VoidHipaaAuthorizationApiArg = {
  matterId: string;
  hipaaAuthorizationVoidSchema: HipaaAuthorizationVoidSchema;
};
export type MattersProvidersRecordRequestsListApiResponse =
  /** status 200  */ TreatmentRecordRequestSchema[];
export type MattersProvidersRecordRequestsListApiArg = {
  matterId: string;
  providerId: string;
};
export type MattersProvidersRecordRequestsCreateApiResponse =
  /** status 201  */ TreatmentRecordRequestSchema;
export type MattersProvidersRecordRequestsCreateApiArg = {
  matterId: string;
  providerId: string;
  createTreatmentRecordRequestSchema: CreateTreatmentRecordRequestSchema;
};
export type MattersProvidersRecordRequestsRetrieveApiResponse =
  /** status 200  */ TreatmentRecordRequestSchema;
export type MattersProvidersRecordRequestsRetrieveApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type MattersProvidersRecordRequestsUpdateApiResponse =
  /** status 200  */ TreatmentRecordRequestSchema;
export type MattersProvidersRecordRequestsUpdateApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  updateTreatmentRecordRequestSchema: UpdateTreatmentRecordRequestSchema;
};
export type MattersProvidersRecordRequestsDestroyApiResponse = unknown;
export type MattersProvidersRecordRequestsDestroyApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type AcceptAlternateContactApiResponse =
  /** status 200  */ ForkRequestResultSchema;
export type AcceptAlternateContactApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  acceptAlternateContactSchema: AcceptAlternateContactSchema;
};
export type MattersProvidersRecordRequestsAuditLogsListApiResponse =
  /** status 200  */ TreatmentRecordRequestAuditLogSchema[];
export type MattersProvidersRecordRequestsAuditLogsListApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type MattersProvidersRecordRequestsAuditLogsCreateApiResponse =
  /** status 200  */ TreatmentRecordRequestAuditLogSchema;
export type MattersProvidersRecordRequestsAuditLogsCreateApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  createTreatmentRecordRequestAuditLogSchema: CreateTreatmentRecordRequestAuditLogSchema;
};
export type MattersProvidersRecordRequestsAuditLogsRetrieveApiResponse =
  /** status 200  */ TreatmentRecordRequestAuditLogSchema;
export type MattersProvidersRecordRequestsAuditLogsRetrieveApiArg = {
  logId: string;
  matterId: string;
  providerId: string;
  requestId: string;
};
export type MattersProvidersRecordRequestsAuditLogsUpdateApiResponse =
  /** status 200  */ TreatmentRecordRequestAuditLogSchema;
export type MattersProvidersRecordRequestsAuditLogsUpdateApiArg = {
  logId: string;
  matterId: string;
  providerId: string;
  requestId: string;
  updateTreatmentRecordRequestAuditLogSchema: UpdateTreatmentRecordRequestAuditLogSchema;
};
export type MattersProvidersRecordRequestsAuditLogsDestroyApiResponse = unknown;
export type MattersProvidersRecordRequestsAuditLogsDestroyApiArg = {
  logId: string;
  matterId: string;
  providerId: string;
  requestId: string;
};
export type MattersProvidersRecordRequestsChangeStatusCreateApiResponse =
  unknown;
export type MattersProvidersRecordRequestsChangeStatusCreateApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  changeTreatmentRecordRequestStatusSchema: ChangeTreatmentRecordRequestStatusSchema;
};
export type MattersProvidersRecordRequestsChannelsListApiResponse =
  /** status 200  */ TreatmentRecordRequestChannelSchema[];
export type MattersProvidersRecordRequestsChannelsListApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type MattersProvidersRecordRequestsChannelsCreateApiResponse =
  /** status 201  */ TreatmentRecordRequestChannelSchema;
export type MattersProvidersRecordRequestsChannelsCreateApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  createTreatmentRecordRequestChannelSchema: CreateTreatmentRecordRequestChannelSchema;
};
export type MattersProvidersRecordRequestsChannelsRetrieveApiResponse =
  /** status 200  */ TreatmentRecordRequestChannelSchema;
export type MattersProvidersRecordRequestsChannelsRetrieveApiArg = {
  channelId: string;
  matterId: string;
  providerId: string;
  requestId: string;
};
export type MattersProvidersRecordRequestsChannelsUpdateApiResponse =
  /** status 200  */ TreatmentRecordRequestChannelSchema;
export type MattersProvidersRecordRequestsChannelsUpdateApiArg = {
  channelId: string;
  matterId: string;
  providerId: string;
  requestId: string;
  updateTreatmentRecordRequestChannelSchema: UpdateTreatmentRecordRequestChannelSchema;
};
export type MattersProvidersRecordRequestsChannelsDestroyApiResponse = unknown;
export type MattersProvidersRecordRequestsChannelsDestroyApiArg = {
  channelId: string;
  matterId: string;
  providerId: string;
  requestId: string;
};
export type GetFollowupHistoryApiResponse =
  /** status 200  */ FollowupHistoryResponse;
export type GetFollowupHistoryApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type GetFollowupOutcomeApiResponse =
  /** status 200  */ MedRecordsFollowUpOutcomeSchema;
export type GetFollowupOutcomeApiArg = {
  /** The matter ID */
  matterId: string;
  /** The medical provider ID */
  providerId: string;
  /** The treatment record request ID */
  requestId: string;
};
export type GetHipaaEmailTemplateApiResponse =
  /** status 200  */ HipaaEmailTemplateSchema;
export type GetHipaaEmailTemplateApiArg = {
  coverPageFrom?: string;
  coverPageMessage?: string;
  coverPageTo?: string;
  matterId: string;
  providerId: string;
  requestId: string;
};
export type GetHipaaSubmissionStatusApiResponse =
  /** status 200  */ HipaaSubmissionStatusResponseSchema;
export type GetHipaaSubmissionStatusApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type MattersProvidersRecordRequestsInvoicesListApiResponse =
  /** status 200  */ TreatmentRecordRequestInvoiceSchema[];
export type MattersProvidersRecordRequestsInvoicesListApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type MattersProvidersRecordRequestsInvoicesCreateApiResponse =
  /** status 201  */ TreatmentRecordRequestInvoiceSchema;
export type MattersProvidersRecordRequestsInvoicesCreateApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  createTreatmentRecordRequestInvoiceSchema: CreateTreatmentRecordRequestInvoiceSchema;
};
export type MattersProvidersRecordRequestsInvoicesRetrieveApiResponse =
  /** status 200  */ TreatmentRecordRequestInvoiceSchema;
export type MattersProvidersRecordRequestsInvoicesRetrieveApiArg = {
  invoiceId: string;
  matterId: string;
  providerId: string;
  requestId: string;
};
export type MattersProvidersRecordRequestsInvoicesUpdateApiResponse =
  /** status 200  */ TreatmentRecordRequestInvoiceSchema;
export type MattersProvidersRecordRequestsInvoicesUpdateApiArg = {
  invoiceId: string;
  matterId: string;
  providerId: string;
  requestId: string;
};
export type RequestHipaaPackageRetrieveApiResponse =
  /** status 200  */ HipaaPackageSchema[];
export type RequestHipaaPackageRetrieveApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type RequestPackageComponentListApiResponse =
  /** status 200  */ PackageComponentSchema[];
export type RequestPackageComponentListApiArg = {
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
};
export type RequestPackageComponentCreateApiResponse =
  /** status 201  */ PackageComponentSchema;
export type RequestPackageComponentCreateApiArg = {
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
  createPackageComponent: CreatePackageComponent;
};
export type RequestPackageComponentRetrieveApiResponse =
  /** status 200  */ PackageComponentSchema;
export type RequestPackageComponentRetrieveApiArg = {
  id: string;
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
};
export type RequestPackageComponentUpdateApiResponse =
  /** status 200  */ PackageComponentSchema;
export type RequestPackageComponentUpdateApiArg = {
  id: string;
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
  patchedUpdatePackageComponent: UpdatePackageComponent;
};
export type RequestPackageComponentDeleteApiResponse = unknown;
export type RequestPackageComponentDeleteApiArg = {
  id: string;
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
};
export type RequestPackageComponentReorderApiResponse =
  /** status 200  */ PackageComponentSchema;
export type RequestPackageComponentReorderApiArg = {
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
  reorderComponentsRequest: ReorderComponentsRequest;
};
export type RequestPackageComponentSearchTemplatesApiResponse =
  /** status 200  */ SearchResults;
export type RequestPackageComponentSearchTemplatesApiArg = {
  /** Filter by template category */
  category?: string;
  /** Include global templates (default: true) */
  includeGlobal?: boolean;
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
  /** Search term for template name/description */
  search?: string;
};
export type RequestPackageComponentValidateAllApiResponse =
  /** status 200  */ PackageValidationResponse;
export type RequestPackageComponentValidateAllApiArg = {
  matterId: string;
  packageId: string;
  providerId: string;
  requestId: string;
};
export type RequestHipaaPackageRetrieve2ApiResponse =
  /** status 200  */ HipaaPackageSchema;
export type RequestHipaaPackageRetrieve2ApiArg = {
  id: string;
  matterId: string;
  providerId: string;
  requestId: string;
};
export type RequestHipaaPackageCreateWithDefaultsApiResponse =
  /** status 201  */ HipaaPackageSchema;
export type RequestHipaaPackageCreateWithDefaultsApiArg = {
  id: string;
  matterId: string;
  providerId: string;
  requestId: string;
};
export type RequestHipaaPackagePublishApiResponse =
  /** status 200  */ HipaaPackageSchema;
export type RequestHipaaPackagePublishApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type RequestHipaaPackageRenderApiResponse =
  /** status 200  */ RenderWorkflowResponse;
export type RequestHipaaPackageRenderApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type RequestHipaaPackageUploadApiResponse =
  /** status 201  */ HipaaPackageSchema;
export type RequestHipaaPackageUploadApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  body: {
    blob_id: string;
  };
};
export type MattersProvidersRecordRequestsRecordsListApiResponse =
  /** status 200  */ TreatmentRecordRequestRecordSchema[];
export type MattersProvidersRecordRequestsRecordsListApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type MattersProvidersRecordRequestsRecordsCreateApiResponse =
  /** status 200  */ TreatmentRecordRequestRecordSchema;
export type MattersProvidersRecordRequestsRecordsCreateApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  createTreatmentRecordRequestRecordSchema: CreateTreatmentRecordRequestRecordSchema;
};
export type MattersProvidersRecordRequestsRecordsRetrieveApiResponse =
  /** status 200  */ TreatmentRecordRequestRecordSchema;
export type MattersProvidersRecordRequestsRecordsRetrieveApiArg = {
  matterId: string;
  providerId: string;
  recordId: string;
  requestId: string;
};
export type MattersProvidersRecordRequestsRecordsDestroyApiResponse = unknown;
export type MattersProvidersRecordRequestsRecordsDestroyApiArg = {
  matterId: string;
  providerId: string;
  recordId: string;
  requestId: string;
};
export type ResendRecordRequestApiResponse =
  /** status 200  */ ForkRequestResultSchema;
export type ResendRecordRequestApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  resendTreatmentRecordRequestSchema: ResendTreatmentRecordRequestSchema;
};
export type RetryExistingContactApiResponse =
  /** status 200  */ ForkRequestResultSchema;
export type RetryExistingContactApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  retryTreatmentRecordRequestSchema: RetryTreatmentRecordRequestSchema;
};
export type SendFollowupTransmissionApiResponse =
  /** status 200  */ FollowupTriggeredResponse;
export type SendFollowupTransmissionApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  sendFollowupSchema: SendFollowupSchema;
};
export type MattersProvidersRecordRequestsSendBlandCallCreateApiResponse =
  unknown;
export type MattersProvidersRecordRequestsSendBlandCallCreateApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  voiceAiCallArgs: VoiceAiCallArgs;
};
export type SubmitHipaaPackageApiResponse = unknown;
export type SubmitHipaaPackageApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  submitHipaaPackageSchema: SubmitHipaaPackageSchema;
};
export type TransmissionStrategyApiResponse =
  /** status 200  */ TransmissionStrategyConfig;
export type TransmissionStrategyApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
};
export type TransmissionStrategy2ApiResponse =
  /** status 200  */ TransmissionStrategyConfig;
export type TransmissionStrategy2ApiArg = {
  matterId: string;
  providerId: string;
  requestId: string;
  transmissionStrategySchema: TransmissionStrategySchema;
};
export type TreatmentRecordRequestHipaaAuthorizationSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  client_physical_id?: (string | string) | null;
  authorization_template_id?: (string | string) | null;
};
export type CreateTreatmentRecordRequestHipaaAuthorizationSchema = {
  client_physical_id?: (string | string) | null;
  authorization_template_id?: (string | string) | null;
};
export type UpdateTreatmentRecordRequestHipaaAuthorizationSchema = {
  client_physical_id?: (string | string) | null;
  authorization_template_id?: (string | string) | null;
};
export type DocumentInstance = {
  /** * `CREATED` - Created
   * `SENT` - Sent
   * `COMPLETED` - Completed
   * `VOIDED` - Voided
   * `SIGNED` - Signed */
  status: "CREATED" | "SENT" | "COMPLETED" | "VOIDED" | "SIGNED";
  external_document_reference: string;
  requires_signatures?: boolean;
  detailed_agreement_info?: any;
  /** Whether this document was auto-generated by a workflow */
  auto_generated?: boolean;
  /** Snapshot of field values after validation/prefill when the document was created. */
  field_values?: any;
  merge_fields?: any;
  /** Source of field values: 'system' for AI/FinchGPT or user UUID */
  field_values_source?: string | null;
};
/**
 * Embedded v2 Template data returned by the document instance serializer.
 * NOTE: This type was manually added to replace `{ [key: string]: any }`.
 * It will be overwritten on next `pnpm generate:api` — update the OpenAPI
 * spec to make this permanent.
 */
export type EmbeddedDocumentTemplate = {
  id: string;
  name: string;
  display_name?: string | null;
  format: "PDF" | "DOCX" | "HTML" | "SMS" | "EXTERNAL";
  category:
    | "HIPAA_COVERSHEET"
    | "HIPAA_AUTHORIZATION"
    | "FOIA_LETTER"
    | "LIEN_NOTICE"
    | "RETAINER"
    | "LOR_GENERIC"
    | "LOR_FIRST_PARTY"
    | "LOR_THIRD_PARTY"
    | "LOR_HEALTH"
    | "WELCOME_LETTER"
    | "DROP_LETTER"
    | "JOINT_VENTURE_NOTICE"
    | "CLIENT_COMMUNICATION"
    | "MEDICAL_RECORDS_REQUEST"
    | "AFFIDAVIT"
    | "LETTER_OF_PROTECTION"
    | "PRESERVATION_LETTER"
    | "PIP_DEMAND"
    | "OTHER";
  scope?: "GLOBAL" | "FIRM";
  status?: "ACTIVE" | "SUPERSEDED" | "ARCHIVED";
  requires_signatures?: boolean;
  is_default?: boolean;
  version?: number;
  version_group?: string;
  firm_id?: string | null;
  attorney_id?: string | null;
};
export type DocumentInstanceRead = {
  id: string;
  /** * `CREATED` - Created
   * `SENT` - Sent
   * `COMPLETED` - Completed
   * `VOIDED` - Voided
   * `SIGNED` - Signed */
  status: "CREATED" | "SENT" | "COMPLETED" | "VOIDED" | "SIGNED";
  external_document_reference: string;
  /** Return v2 Template data. Raises if v2_template is missing. */
  document_template: EmbeddedDocumentTemplate | null;
  requires_signatures?: boolean;
  detailed_agreement_info?: any;
  created_at: string;
  /** Whether this document was auto-generated by a workflow */
  auto_generated?: boolean;
  /** Snapshot of field values after validation/prefill when the document was created. */
  field_values?: any;
  merge_fields?: any;
  uploaded_artifact_id: string | null;
  cached_pdf_url: string | null;
  /** Source of field values: 'system' for AI/FinchGPT or user UUID */
  field_values_source?: string | null;
  uploaded_filename: string | null;
};
export type HipaaAuthorizationDocumentReferenceSchema = {
  document_instance_id?: (string | string) | null;
};
export type HipaaAuthorizationReminderSchema = {
  document_instance_id?: (string | string) | null;
  send_sms?: boolean;
  sms_message?: string | null;
  sms_recipient_phone?: string | null;
};
export type HipaaAuthorizationSendSchema = {
  client_email: string;
  client_name?: string | null;
  client_phone_number?: string | null;
  send_sms?: boolean | null;
  sms_message?: string | null;
};
export type HipaaAuthorizationVoidSchema = {
  document_instance_id?: (string | string) | null;
};
export type TreatmentRecordRequestActor = "user" | "agent";
export type TreatmentRecordTypes =
  | "Bills"
  | "Records"
  | "Facility Records"
  | "Facility Bills"
  | "Radiology"
  | "ER Physician Bills"
  | "Other"
  | "Unknown";
export type TreatmentRecordRequestStatus =
  | "not_ready"
  | "pending"
  | "request_submitted"
  | "request_received"
  | "awaiting_invoice"
  | "pending_payment"
  | "records_pending"
  | "records_delivered"
  | "records_ingested"
  | "rejected"
  | "cancelled"
  | "auto_retried";
export type Blockers =
  | "HIPAA_PACKAGE_NOT_READY"
  | "CLIENT_INFORMATION_NOT_ENTERED"
  | "PROVIDER_CONTACT_INFORMATION_NOT_ENTERED"
  | "PORTAL_REQUEST_ID_REQUIRED"
  | "NO_REQUEST_SENT_AT"
  | "VOICE_AI_INFORMATION_NOT_ENTERED"
  | "FOLLOWUP_HIPAA_PACKAGE_NOT_SUBMITTED"
  | "FOLLOWUP_CHANNEL_NOT_CONFIGURED"
  | "FOLLOWUP_CHANNEL_UNSUPPORTED"
  | "FOLLOWUP_FAX_NUMBER_MISSING"
  | "FOLLOWUP_EMAIL_ADDRESS_MISSING"
  | "FOLLOWUP_TASK_TERMINAL";
export type TreatmentRecordRequestAutomationBlockedSchema = {
  details?: string | null;
  checked_status_at?: string | null;
  status?: "blocked";
  blocked_by?: Blockers[];
};
export type TreatmentRecordRequestAutomationFailedSchema = {
  details?: string | null;
  checked_status_at?: string | null;
  status?: "failed";
};
export type TreatmentRecordRequestAutomationIdleSchema = {
  details?: string | null;
  checked_status_at?: string | null;
  status?: "idle";
};
export type TreatmentRecordRequestAutomationRunningSchema = {
  details?: string | null;
  checked_status_at?: string | null;
  status?: "running";
};
export type TreatmentRecordRequestAutomationSleepingSchema = {
  details?: string | null;
  checked_status_at?: string | null;
  status?: "sleeping";
  sleep_until: string;
};
export type PatientInformation = {
  client_name: string;
  client_date_of_birth: string;
};
export type TreatmentRecordRequestChannelType =
  | "portal"
  | "human"
  | "email"
  | "fax"
  | "mail"
  | "phone";
export type RequestDetails = {
  request_method: TreatmentRecordRequestChannelType;
  request_sent_at: string;
  request_method_target: string;
  contact_number: string;
};
export type RequesteeInformation = {
  requestee_name: string;
};
export type VoiceAiCallArgs = {
  patient_information: PatientInformation;
  request_details: RequestDetails;
  requestee_information: RequesteeInformation;
  /** Human-readable description of the requested records (e.g., Medical Records, Bills, Radiology). */
  request_type_label?: string | null;
  /** Skip business-hours scheduling and execute the call immediately. Used for manual/bulk calls that should run ASAP. */
  skip_scheduling_delay?: boolean;
};
export type MrFollowupObservationSchemaVersion = "mr_followup_observation_v1";
export type MrFollowupConnectionOutcome =
  | "HUMAN"
  | "VOICEMAIL"
  | "IVR"
  | "NO_ANSWER"
  | "BUSY"
  | "INVALID_NUMBER"
  | "FAILED"
  | "UNKNOWN";
export type MrFollowupEtaUnit =
  | "HOURS"
  | "DAYS"
  | "WEEKS"
  | "BUSINESS_DAYS"
  | "BUSINESS_HOURS";
export type MrFollowupConnectionFollowupInstructions = {
  details?: string | null;
  eta_value?: number | null;
  eta_unit?: MrFollowupEtaUnit;
  phone?: string | null;
};
export type MrFollowupConnection = {
  outcome: MrFollowupConnectionOutcome;
  attempts_before_connect?: number | null;
  voicemail_left?: boolean | null;
  followup_instructions?: MrFollowupConnectionFollowupInstructions;
};
export type MrFollowupContactOutcome =
  | "WRONG_NUMBER_REDIRECT"
  | "WRONG_PROVIDER"
  | "INFO_INSUFFICIENT"
  | "CALLBACK_REQUESTED"
  | "NOT_FOUND_REDIRECT"
  | "NOT_FOUND_RETRY"
  | "REQUEST_FOUND"
  | "UNKNOWN";
export type MrFollowupRedirectMethod =
  | "FAX"
  | "EMAIL"
  | "PORTAL"
  | "MAIL"
  | "OTHER";
export type MrFollowupContactRedirect = {
  new_phone?: string | null;
  new_destination?: string | null;
  new_destination_method?: MrFollowupRedirectMethod;
};
export type MrFollowupContactCallback = {
  callback_time?: string | null;
  reason?: string | null;
  callback_phone?: string | null;
};
export type MrFollowupContactInfoInsufficient = {
  info_needed?: string | null;
};
export type MrFollowupContact = {
  outcome: MrFollowupContactOutcome;
  department_reached?: string | null;
  representative_name?: string | null;
  redirect?: MrFollowupContactRedirect;
  callback?: MrFollowupContactCallback;
  info_insufficient?: MrFollowupContactInfoInsufficient;
};
export type MrFollowupStatusOutcome =
  | "IN_PROCESSING"
  | "BLOCKED_LETTERHEAD"
  | "BLOCKED_AUTH"
  | "BLOCKED_DOCS"
  | "REJECTED_NOT_PATIENT"
  | "REJECTED_NO_RECORDS"
  | "REJECTED_AFTER_PROCESSING"
  | "RECORDS_READY"
  | "UNKNOWN";
export type MrFollowupInProcessing = {
  eta_value?: number | null;
  eta_unit?: MrFollowupEtaUnit;
  followup_contact_name?: string | null;
  followup_phone?: string | null;
  reference_number?: string | null;
  additional_reference_numbers?: string[] | null;
};
export type MrFollowupBlocked = {
  details?: string | null;
};
export type MrFollowupRejected = {
  details?: string | null;
  representative_name?: string | null;
};
export type MrFollowupStatus = {
  outcome: MrFollowupStatusOutcome;
  in_processing?: MrFollowupInProcessing;
  blocked?: MrFollowupBlocked;
  rejected?: MrFollowupRejected;
};
export type MrFollowupInvoiceOutcome =
  | "NO_INVOICE"
  | "INVOICE_SENT"
  | "INVOICE_PENDING"
  | "INVOICE_UNKNOWN"
  | "UNKNOWN";
export type MrFollowupInvoiceChannel =
  | "FAX"
  | "EMAIL"
  | "MAIL"
  | "PORTAL"
  | "OTHER";
export type MrFollowupInvoice = {
  outcome: MrFollowupInvoiceOutcome;
  amount?: number | null;
  channel?: MrFollowupInvoiceChannel;
  destination?: string | null;
  date_sent?: string | null;
  eta?: string | null;
  invoice_number?: string | null;
};
export type MrFollowupPaymentOutcome =
  | "PAYMENT_ON_CALL"
  | "PAYMENT_OFFLINE_MAIL"
  | "PAYMENT_OFFLINE_ONLINE"
  | "PAYMENT_PENDING"
  | "PAYMENT_CONFIRMED"
  | "UNKNOWN";
export type MrFollowupPayment = {
  outcome?: MrFollowupPaymentOutcome;
  amount_paid?: number | null;
  confirmation_number?: string | null;
  payee_name?: string | null;
  mailing_address?: string | null;
  portal_url?: string | null;
  account_instructions?: string | null;
  date_paid?: string | null;
};
export type MrFollowupDeliveryOutcome =
  | "RECORDS_SENT"
  | "RECORDS_PENDING_DELIVERY"
  | "RECORDS_READY_PICKUP"
  | "UNKNOWN";
export type MrFollowupDeliveryMethod =
  | "FAX"
  | "EMAIL"
  | "PORTAL"
  | "MAIL"
  | "COURIER"
  | "PICKUP"
  | "OTHER";
export type MrFollowupDelivery = {
  outcome?: MrFollowupDeliveryOutcome;
  method?: MrFollowupDeliveryMethod;
  destination?: string | null;
  date_sent?: string | null;
  eta?: string | null;
  portal_url?: string | null;
  access_instructions?: string | null;
  pickup_location?: string | null;
  special_instructions?: string | null;
};
export type AlternateContactHandleType = "fax" | "email" | "mailing_address";
export type AlternateContactSchema = {
  /** Type of contact method (fax/email/mailing address). */
  handle_type: AlternateContactHandleType;
  /** The actual contact value (fax number, email, or mailing address). */
  value: string;
  /** Optional human-readable label or description. */
  label?: string | null;
  /** Optional confidence score from AI extraction (0-1). */
  confidence?: number | null;
};
export type MrFollowupEvidenceEntry = {
  field: string;
  quote: string;
};
export type MrFollowupObservationV1 = {
  schema_version: MrFollowupObservationSchemaVersion;
  summary: string;
  related_reference_numbers?: string[] | null;
  connection: MrFollowupConnection;
  contact?: MrFollowupContact;
  status?: MrFollowupStatus;
  invoice?: MrFollowupInvoice;
  payment?: MrFollowupPayment;
  delivery?: MrFollowupDelivery;
  alternate_contacts?: AlternateContactSchema[];
  evidence: MrFollowupEvidenceEntry[];
};
export type MrFollowupDecisionSchemaVersion = "mr_followup_decision_v1";
export type MrFollowupNextActor = "SYSTEM" | "USER" | "BPO" | "STOP";
export type MrFollowupNextAction =
  | "RETRY_CALL"
  | "WAIT_FOR_CALLBACK"
  | "CALL_BACK_AT_TIME"
  | "CALL_NEW_NUMBER"
  | "RESEARCH_NEW_NUMBER"
  | "RESUBMIT_SAME_DESTINATION"
  | "RESUBMIT_NEW_DESTINATION"
  | "PROVIDE_MISSING_INFO"
  | "PROVIDE_MISSING_DOCS"
  | "VERIFY_PATIENT_INFO"
  | "WAIT_FOR_PROCESSING"
  | "WAIT_FOR_INVOICE"
  | "PAY_INVOICE"
  | "WAIT_FOR_PAYMENT_CONFIRMATION"
  | "CHECK_INBOX_FOR_RECORDS"
  | "WAIT_FOR_RECORDS_DELIVERY"
  | "RETRIEVE_RECORDS"
  | "ESCALATE_TO_BPO"
  | "STOP_NO_ACTION"
  | "STOP_REJECTED";
export type MrFollowupDecisionActionContext = {
  notes?: string | null;
  callback_time?: string | null;
  new_phone?: string | null;
  new_destination?: string | null;
  followup_eta_value?: number | null;
  followup_eta_unit?: MrFollowupEtaUnit;
};
export type MrFollowupDecisionV1 = {
  schema_version: MrFollowupDecisionSchemaVersion;
  next_actor: MrFollowupNextActor;
  next_action: MrFollowupNextAction;
  next_action_at?: string | null;
  required_user_inputs: string[];
  rationale: string;
  action_context?: MrFollowupDecisionActionContext;
};
export type MrFollowupQualitySchemaVersion = "mr_followup_quality_v1";
export type MrFollowupQualityFailureMode =
  | "SCHEMA_VIOLATION"
  | "UNGROUNDED_CLAIMS"
  | "MISCLASSIFIED_OUTCOME"
  | "MISSING_KEY_PRIMITIVE"
  | "BAD_EVIDENCE"
  | "BAD_NEXT_ACTION"
  | "OTHER";
export type MrFollowupQualityV1 = {
  schema_version: MrFollowupQualitySchemaVersion;
  overall_score: number;
  should_trust: boolean;
  notes: string;
  grounding_score: number;
  decision_score: number;
  evidence_score: number;
  primary_failure_mode?: MrFollowupQualityFailureMode;
};
export type ContactDiscoveryCallSummarySchema = {
  /** Short text describing what the facility told us. */
  call_summary: string;
  /** List of submission channels (portal, fax, email) mentioned during the call. */
  submission_methods?: string[];
  /** Documents or prerequisites (HIPAA, ID, invoices) called out by the facility. */
  required_documents?: string[];
  /** Structured alternates (fax numbers, mailing addresses) discovered during the call. */
  alternate_contacts?: AlternateContactSchema[];
  /** Optional free-form notes for additional context. */
  notes?: string | null;
};
export type TransmissionStrategyConfig = {
  enabled?: boolean;
  channel?: TreatmentRecordRequestChannelType;
  interval_days?: number;
  max_attempts?: number;
  stop_on_voice_ai_contact?: boolean;
  stop_on_status_change?: boolean;
  last_transmission_at?: string | null;
  next_transmission_at?: string | null;
  total_transmissions_sent?: number;
  failed_attempts?: number;
};
export type TreatmentRecordRequestMetadataSchema = {
  slack_message_id?: string | null;
  disable_automations?: boolean;
  automation_state_v2?:
    | (
        | ({
            status: "blocked";
          } & TreatmentRecordRequestAutomationBlockedSchema)
        | ({
            status: "failed";
          } & TreatmentRecordRequestAutomationFailedSchema)
        | ({
            status: "idle";
          } & TreatmentRecordRequestAutomationIdleSchema)
        | ({
            status: "running";
          } & TreatmentRecordRequestAutomationRunningSchema)
        | ({
            status: "sleeping";
          } & TreatmentRecordRequestAutomationSleepingSchema)
      )
    | null;
  ad_hoc_voice_ai_args?: VoiceAiCallArgs;
  front_conversation_id?: string | null;
  front_conversation_url?: string | null;
  email_sent_at?: string | null;
  /** Number of days between voice AI follow-up calls */
  voice_ai_check_interval_days?: number;
  next_scheduled_call?: string | null;
  request_submitted_at?: string | null;
  initial_contact_method_call_completed_at?: string | null;
  voice_ai_call_summary?: string | null;
  voice_ai_discovered_alternates?: {
    [key: string]: any;
  }[];
  voice_ai_call_id?: string | null;
  superseded_by_request_id?: string | null;
  supersession_reason?: string | null;
  last_notification_category?: string | null;
  last_notification_subcategory?: string | null;
  last_call_key_information?: {
    [key: string]: any;
  };
  last_voice_ai_call_at?: string | null;
  last_voice_ai_call_summary?: string | null;
  mr_followup_vnext_call_id?: string | null;
  mr_followup_vnext_generated_at?: string | null;
  mr_followup_observation_v1?: MrFollowupObservationV1;
  mr_followup_decision_v1?: MrFollowupDecisionV1;
  mr_followup_quality_v1?: MrFollowupQualityV1;
  mr_followup_vnext_observation_used_audio?: boolean | null;
  mr_followup_vnext_observation_fallback_reason?: string | null;
  mr_followup_vnext_decision_used_audio?: boolean | null;
  mr_followup_vnext_decision_fallback_reason?: string | null;
  mr_followup_vnext_quality_used_audio?: boolean | null;
  mr_followup_vnext_quality_fallback_reason?: string | null;
  dynamic_retry_delay_hours?: number | null;
  contact_discovery_summary?: ContactDiscoveryCallSummarySchema;
  contact_discovery_last_updated_at?: string | null;
  hipaa_package_locked?: boolean;
  hipaa_package_locked_at?: string | null;
  hipaa_package_submission_channel?: TreatmentRecordRequestChannelType;
  hipaa_package_submission_workflow_id?: string | null;
  alternate_contact?: AlternateContactSchema;
  forked_from_request_id?: string | null;
  transmission_strategy?: TransmissionStrategyConfig;
  notes?: string | null;
};
export type TreatmentRecordRequestPortalType =
  | "smart_request"
  | "mro"
  | "chartswap";
export type PortalRecordType = {
  id: string | string;
  created_at: string;
  modified_at: string;
  original_name?: string | null;
  record_type: TreatmentRecordTypes;
};
export type PortalProvider = {
  id: string | string;
  created_at: string;
  modified_at: string;
  name: string;
  portal: TreatmentRecordRequestPortalType;
  active?: boolean;
  external_id?: string | null;
  site?: string | null;
  website?: string | null;
  phone?: string | null;
  email?: string | null;
  fax?: string | null;
  address_line_1?: string | null;
  address_line_2?: string | null;
  city?: string | null;
  state?: string | null;
  postal_code?: string | null;
  country?: string | null;
  record_types?: PortalRecordType[] | null;
};
export type TreatmentRecordRequestChannelSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  type: TreatmentRecordRequestChannelType;
  portal_provider_id?: (string | string) | null;
  phone_number?: string | null;
  address?: string | null;
  email?: string | null;
  fax?: string | null;
  instructions?: string | null;
  portal_record_request_id?: string | null;
  provider_contact_unit_handle_id?: (string | string) | null;
  provider_directory_contact_point_id?: (string | string) | null;
  portal_provider?: PortalProvider;
};
export type FaxTransmissionStatusSchema = {
  id?: (string | string) | null;
  status?: ("pending" | "sent" | "delivered" | "failed") | null;
  sent_at?: string | null;
  delivered_at?: string | null;
  failed_at?: string | null;
  transmission_id?: string | null;
  error_message?: string | null;
};
export type EmailTransmissionStatusSchema = {
  sent_at?: string | null;
  front_conversation_id?: string | null;
  front_conversation_url?: string | null;
  recipient_email?: string | null;
};
export type TreatmentRecordRequestSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  provider_id: string | string;
  actor?: TreatmentRecordRequestActor;
  is_certified?: boolean;
  is_urgent?: boolean;
  provided_records?: TreatmentRecordTypes[];
  status?: TreatmentRecordRequestStatus;
  metadata?: TreatmentRecordRequestMetadataSchema;
  channel?: TreatmentRecordRequestChannelSchema;
  fax_transmission_status?: FaxTransmissionStatusSchema;
  email_transmission_status?: EmailTransmissionStatusSchema;
  task_id?: (string | string) | null;
};
export type BaseTreatmentRecordRequestChannelSchema = {
  type: TreatmentRecordRequestChannelType;
  portal_provider_id?: (string | string) | null;
  phone_number?: string | null;
  address?: string | null;
  email?: string | null;
  fax?: string | null;
  instructions?: string | null;
  portal_record_request_id?: string | null;
  provider_contact_unit_handle_id?: (string | string) | null;
  provider_directory_contact_point_id?: (string | string) | null;
};
export type CreateTreatmentRecordRequestSchema = {
  actor?: TreatmentRecordRequestActor;
  is_certified?: boolean;
  is_urgent?: boolean;
  provided_records?: TreatmentRecordTypes[];
  status?: TreatmentRecordRequestStatus;
  metadata?: TreatmentRecordRequestMetadataSchema;
  channel?: BaseTreatmentRecordRequestChannelSchema;
};
export type UpdateTreatmentRecordRequestSchema = {
  request_id: string | string;
  actor?: TreatmentRecordRequestActor;
  is_certified?: boolean | null;
  is_urgent?: boolean | null;
  provided_records?: TreatmentRecordTypes[] | null;
  status?: TreatmentRecordRequestStatus;
  metadata?: TreatmentRecordRequestMetadataSchema;
};
export type ForkRequestResultSchema = {
  /** ID of the original request that was superseded */
  old_request_id: string | string;
  /** ID of the newly created request with alternate contact */
  new_request_id: string | string;
  /** ID of the task that was relinked to the new request */
  task_id: string | string;
  /** ID of the new channel created for the alternate contact */
  new_channel_id: string | string;
};
export type AcceptAlternateContactSchema = {
  /** Type of alternate contact method (fax or mailing address) */
  handle_type: AlternateContactHandleType;
  /** The actual contact value (fax number or mailing address) */
  value: string;
  /** Optional human-readable label or description */
  label?: string | null;
  /** Optional confidence score from AI extraction (0-1) */
  confidence?: number | null;
};
export type TreatmentRecordRequestAction =
  | "change_status"
  | "agent_run"
  | "human_update";
export type TreatmentRecordRequestActionOutcome =
  | "success"
  | "failure"
  | "pending"
  | "not_applicable";
export type TreatmentRecordRequestAuditLogSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  actor?: TreatmentRecordRequestActor;
  user_id?: (string | string) | null;
  action?: TreatmentRecordRequestAction;
  outcome?: TreatmentRecordRequestActionOutcome;
  details?: string | null;
  previous_status: TreatmentRecordRequestStatus;
  new_status: TreatmentRecordRequestStatus;
  request_id: string | string;
};
export type CreateTreatmentRecordRequestAuditLogSchema = {
  actor?: TreatmentRecordRequestActor;
  user_id?: (string | string) | null;
  action?: TreatmentRecordRequestAction;
  outcome?: TreatmentRecordRequestActionOutcome;
  details?: string | null;
  previous_status: TreatmentRecordRequestStatus;
  new_status: TreatmentRecordRequestStatus;
  request_id: string | string;
};
export type UpdateTreatmentRecordRequestAuditLogSchema = {
  action?: TreatmentRecordRequestAction;
  outcome?: TreatmentRecordRequestActionOutcome;
  details?: string | null;
  previous_status?: TreatmentRecordRequestStatus;
  new_status?: TreatmentRecordRequestStatus;
};
export type ChangeTreatmentRecordRequestStatusLogSchema = {
  details?: string | null;
};
export type Reason =
  | "treatment_completed"
  | "request_submitted_via_portal"
  | "request_submitted_via_mail"
  | "request_submitted_via_fax"
  | "request_submitted_via_email"
  | "request_updated_via_voice_ai"
  | "request_updated_via_portal"
  | "invoice_paid_via_portal"
  | "records_ingested_via_portal"
  | "manual";
export type ChangeTreatmentRecordRequestStatusSchema = {
  new_status: TreatmentRecordRequestStatus;
  log?: ChangeTreatmentRecordRequestStatusLogSchema;
  override_requirements?: boolean;
  reason?: Reason;
  attachments?: string[] | null;
};
export type CreateTreatmentRecordRequestChannelSchema = {
  type: TreatmentRecordRequestChannelType;
  portal_provider_id?: (string | string) | null;
  phone_number?: string | null;
  address?: string | null;
  email?: string | null;
  fax?: string | null;
  instructions?: string | null;
  portal_record_request_id?: string | null;
  provider_contact_unit_handle_id?: (string | string) | null;
  provider_directory_contact_point_id?: (string | string) | null;
};
export type UpdateTreatmentRecordRequestChannelSchema = {
  type?: TreatmentRecordRequestChannelType;
  phone_number?: string | null;
  address?: string | null;
  email?: string | null;
  fax?: string | null;
  instructions?: string | null;
  portal_record_request_id?: string | null;
  provider_contact_unit_handle_id?: (string | string) | null;
  provider_directory_contact_point_id?: (string | string) | null;
};
export type FollowupHistoryItemSchema = {
  id: string;
  package_type: string;
  channel?: string | null;
  status?: string;
  triggered_by?: string;
  created_at: string;
  transmitted_at?: string | null;
  recipient_name?: string | null;
  fax_transmission_id?: string | null;
  front_message_id?: string | null;
  postgrid_letter_id?: string | null;
};
export type FollowupHistoryResponse = {
  followups: FollowupHistoryItemSchema[];
};
export type FollowupErrorResponse = {
  error: string;
  details?:
    | {
        [key: string]: string;
      }[]
    | null;
};
export type VoiceAiNotificationCategory =
  | "progress_made"
  | "action_needed"
  | "auto_retry";
export type NotificationSubcategory =
  | "request_confirmed"
  | "records_ready"
  | "agent_performance"
  | "missing_information"
  | "process_clarification"
  | "payment_info"
  | "data_mismatch"
  | "timing_issue"
  | "system_issue"
  | "ivr_info_only"
  | "provider_ai_loop";
export type MedRecordsNextAction =
  | "wait_for_records"
  | "check_inbox"
  | "wait_for_timeline"
  | "resubmit_request"
  | "pay_invoice"
  | "verify_patient_info"
  | "provide_missing_docs"
  | "review_call_manually"
  | "use_alternate_contact"
  | "wait_for_retry"
  | "retry_during_business_hours"
  | "no_action_needed"
  | "escalate_to_human";
export type MedRecordsFollowUpOutcomeSchema = {
  /** High-level outcome: progress_made, action_needed, auto_retry */
  category?: VoiceAiNotificationCategory;
  /** Detailed outcome providing specific context */
  subcategory?: NotificationSubcategory;
  /** What should happen next (computed from category/subcategory) */
  next_action: MedRecordsNextAction;
  /** User-centric description: what Voice AI did and what user can do */
  next_action_description: string;
  /** Any ETA mentioned by provider (e.g., '7-10 business days') */
  timeline?: string | null;
  /** Fee amount if payment is required */
  payment_amount?: string | null;
  /** Provider-mentioned required next steps */
  next_steps?: string | null;
  /** Additional contact info discovered (e.g., 'Maria, ext. 234') */
  contact_info?: string | null;
  /** Other relevant call notes */
  notes?: string | null;
  /** One-line summary of the call */
  call_summary?: string | null;
  /** When the last Voice AI call occurred */
  last_call_at?: string | null;
  /** Whether the call reached a human */
  reached_human?: boolean | null;
  /** Whether alternate contact methods were discovered */
  has_alternates?: boolean;
  /** Number of alternate contacts available for action */
  alternates_count?: number;
  /** When the next automated call is scheduled */
  next_scheduled_call?: string | null;
  /** Current status of the treatment request */
  request_status?: TreatmentRecordRequestStatus;
  vnext_observation?: MrFollowupObservationV1;
  vnext_decision?: MrFollowupDecisionV1;
  vnext_quality?: MrFollowupQualityV1;
  vnext_next_actor?: MrFollowupNextActor;
  vnext_next_action?: MrFollowupNextAction;
  vnext_rationale?: string | null;
  vnext_should_trust?: boolean | null;
  vnext_overall_score?: number | null;
};
export type HipaaEmailTemplateSchema = {
  subject: string;
  body: string;
};
export type HipaaSubmissionStatusResponseSchema = {
  channel_type: string;
  front_conversation_id?: string | null;
  front_conversation_url?: string | null;
  conversation_status?: string | null;
  subject?: string | null;
  recipient_email?: string | null;
  sent_at?: string | null;
  assignee_name?: string | null;
  transmission_id?: string | null;
  fax_status?: string | null;
  recipient_number?: string | null;
  delivered_at?: string | null;
  failed_at?: string | null;
  pages?: number | null;
  file_name?: string | null;
  error_message?: string | null;
  tracking_number?: string | null;
  status?: string | null;
};
export type TreatmentRecordRequestInvoiceSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  invoice_number?: string | null;
  amount: number;
  date_received: string;
  date_paid?: string | null;
  invoice_file_id?: (string | string) | null;
};
export type CreateTreatmentRecordRequestInvoiceSchema = {
  invoice_number?: string | null;
  amount: number;
  date_received: string;
  date_paid?: string | null;
  invoice_file_id?: (string | string) | null;
};
export type RenderStatus =
  | "draft"
  | "missing_fields"
  | "queued_for_render"
  | "generating"
  | "ready"
  | "published"
  | "error";
export type PackageSource = "generated" | "manually_uploaded";
export type ComponentType =
  | "template"
  | "global_template"
  | "matter_blob"
  | "static_document"
  | "external_file"
  | "generated_content"
  | "merge_document"
  | "signed_authorization_merge";
export type StaticDocumentTag =
  | "client_id"
  | "attorney_relationship"
  | "reproductive_rights"
  | "texas_affidavit";
export type MissingFieldInfo = {
  field_id: string;
  field_name: string;
  field_source: string;
  context_key?: string | null;
};
export type BlobSchema = {
  id: string | string;
  name: string;
  original_filename: string | null;
  collection_id: string | string;
  collection_name: string;
  file_hash: string;
  file_size: number;
  file_extension: string | null;
  file_mime_type: string | null;
  download_url?: string | null;
  created_at: string;
  modified_at: string;
};
export type TemplateFormat = "PDF" | "DOCX" | "HTML" | "SMS" | "EXTERNAL";
export type TemplateCategory =
  | "HIPAA_COVERSHEET"
  | "HIPAA_AUTHORIZATION"
  | "FOIA_LETTER"
  | "LIEN_NOTICE"
  | "RETAINER"
  | "LOR_GENERIC"
  | "LOR_FIRST_PARTY"
  | "LOR_THIRD_PARTY"
  | "LOR_HEALTH"
  | "WELCOME_LETTER"
  | "DROP_LETTER"
  | "JOINT_VENTURE_NOTICE"
  | "CLIENT_COMMUNICATION"
  | "MEDICAL_RECORDS_REQUEST"
  | "AFFIDAVIT"
  | "LETTER_OF_PROTECTION"
  | "PRESERVATION_LETTER"
  | "PIP_DEMAND"
  | "OTHER";
export type TemplateScope = "GLOBAL" | "FIRM";
export type TemplateStatus = "ACTIVE" | "SUPERSEDED" | "ARCHIVED";
export type ReadTemplateSummary = {
  id: string | string;
  name: string;
  display_name?: string | null;
  format: TemplateFormat;
  category: TemplateCategory;
  scope: TemplateScope;
  firm_id?: (string | string) | null;
  attorney_id?: (string | string) | null;
  attorney_name?: string | null;
  status: TemplateStatus;
  is_default: boolean;
  requires_signatures?: boolean;
  sample_render_status?: string | null;
  preview_render_url?: string | null;
  preview_image_url?: string | null;
  version: number;
  version_group: string;
  created_at: string;
  modified_at: string;
};
export type PackageComponentSchema = {
  component_type: ComponentType;
  order?: number;
  overrides?: {
    [key: string]: string;
  };
  id: string | string;
  package_id: string | string;
  status?: RenderStatus;
  v2_template_id?: (string | string) | null;
  blob_id?: (string | string) | null;
  static_document_tag?: StaticDocumentTag;
  signed_blob_id?: (string | string) | null;
  missing_fields?: {
    [key: string]: MissingFieldInfo;
  };
  resolved_missing_fields?: string[];
  has_manual_edits?: boolean;
  rendered_pdf_url?: string | null;
  rendered_docx_url?: string | null;
  error_message?: string | null;
  blob?: BlobSchema;
  template?: ReadTemplateSummary;
};
export type CustomUserSchema = {
  id: string | string;
  username: string;
  email: string;
  first_name?: string | null;
  last_name?: string | null;
  is_firm_admin?: boolean;
  avatar?: string | null;
  signature?: string | null;
};
export type ContactHandleType =
  | "PHONE"
  | "EMAIL"
  | "WEBSITE"
  | "FAX"
  | "OTHER"
  | "MAILING_ADDRESS";
export type WebSource = {
  /** The URL of the source */
  url: string;
  /** Very short display text for the source URL */
  title: string;
};
export type ContactHandleSchema = {
  id?: (string | string) | null;
  /** The captured contact information. Should contain an E.164 formatted phone number, or an email address, or a website, or a fax number. */
  value?: string | null;
  address_line1?: string | null;
  address_line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  handle_type: ContactHandleType;
  /** Short description of the handle; e.g. 'Billing Dept Toll-Free', 'Front Desk Fax' etc. */
  name?: string | null;
  /** Optional notes about the handle. */
  notes?: string | null;
  /** Citations for the handle. */
  sources?: WebSource[] | null;
  /** Whether this is the preferred contact handle. */
  preferred?: boolean | null;
  division_id?: (string | string) | null;
};
export type ContactRequestCapabilities =
  | "RECORDS_ONLY"
  | "BILLS_ONLY"
  | "RECORDS_AND_BILLS";
export type AgentType =
  | "ingest_transcript_task"
  | "provider_finder"
  | "artifact_digest"
  | "treatment_researcher"
  | "treatment_request_automation"
  | "bland_caller"
  | "voice_ai"
  | "slack_task_bot"
  | "blob_sorter"
  | "front_app_integration"
  | "task_generator"
  | "coverage_extractor"
  | "intake_converter"
  | "airtable_sync"
  | "system"
  | "backfill_script"
  | "domain_event_update_orchestrator"
  | "loa_detector"
  | "rainmaker"
  | "deliverable_sync"
  | "bpo_agent"
  | "loa_chaser"
  | "external_task_rule_engine"
  | "external_task_bulk_create"
  | "entity_sync"
  | "case_activation";
export type ProviderContactUnitHandleSchema = {
  id: string | string;
  provider_unit_id: string | string;
  contact_handle_id: number;
  handle: ContactHandleSchema;
  is_preferred: boolean;
  voice_ai_cadence_days?: number | null;
  capabilities: ContactRequestCapabilities;
  notes?: string | null;
  created_by_id?: (string | string) | null;
  updated_by_id?: (string | string) | null;
  created_by_agent?: AgentType;
};
export type HipaaPackageSchema = {
  id: string | string;
  request_id: string | string;
  status: RenderStatus;
  package_source: PackageSource;
  rendered_pdf_url?: string | null;
  rendered_docx_url?: string | null;
  completed_package_id?: (string | string) | null;
  download_url?: string | null;
  manually_uploaded_url?: string | null;
  components?: PackageComponentSchema[];
  error_message?: string | null;
  approved_at?: string | null;
  approved_by?: CustomUserSchema;
  uploaded_by?: CustomUserSchema;
  provider_contact_unit_handle_id?: (string | string) | null;
  provider_contact_unit_handle?: ProviderContactUnitHandleSchema;
  provider_directory_contact_point_id?: (string | string) | null;
  locked_at?: string | null;
  locked_by_submission_channel?: TreatmentRecordRequestChannelType;
  locked_by_submission_workflow_id?: string | null;
};
export type CreatePackageComponent = {
  component_type: ComponentType;
  order?: number;
  overrides?: {
    [key: string]: string;
  };
  v2_template_id?: (string | string) | null;
  blob_id?: (string | string) | null;
  static_document_tag?: StaticDocumentTag;
  signed_blob_id?: (string | string) | null;
};
export type UpdatePackageComponent = {
  order?: number | null;
  overrides?: {
    [key: string]: string;
  } | null;
  resolved_missing_fields?: string[] | null;
  missing_fields?: {
    [key: string]: MissingFieldInfo;
  } | null;
};
export type ComponentOrderMapping = {
  component_id: string | string;
  order: number;
};
export type ReorderComponentsRequest = {
  components: ComponentOrderMapping[];
};
export type TemplateSearchResult = {
  id: string | string;
  name: string | null;
  display_name: string | null;
  description: string | null;
  template_category: string;
  template_type: string;
  is_firm_template: boolean;
  is_default?: boolean;
};
export type SearchResults = {
  results: TemplateSearchResult[];
};
export type FieldType =
  | "TEXT"
  | "DATE"
  | "CHECKBOX"
  | "IMAGE"
  | "ARRAY"
  | "SIGNATURE"
  | "INITIALS";
export type FieldSource = "MANUAL" | "CONTEXT" | "SIGNING";
export type ContextCategoryMeta = {
  label: string;
  binding_key?: string | null;
  entity_absent_hint?: string | null;
};
export type MatterContextFieldType =
  | "text"
  | "date"
  | "number"
  | "boolean"
  | "datetime"
  | "image"
  | "array";
export type ArrayItemProperty = {
  key: string;
  type: MatterContextFieldType;
  label: string;
  required?: boolean;
};
export type PdfPosition = {
  x: number;
  y: number;
  width: number;
  height: number;
};
export type ReadTemplateField = {
  id: string | string;
  template_id: string | string;
  reference: string;
  field_type: FieldType;
  source: FieldSource;
  context_key?: string | null;
  context_category?: string | null;
  context_category_meta?: ContextCategoryMeta;
  array_item_schema?: ArrayItemProperty[] | null;
  array_item_keys?: string[] | null;
  default_value?: string | null;
  required: boolean;
  display_name?: string | null;
  pdf_page_number?: number | null;
  pdf_position?: PdfPosition;
  created_at: string;
  modified_at: string;
};
export type AnnotationFieldInfo = {
  field_id: string;
  field_name: string;
  field_source: string;
  context_key?: string | null;
  current_value?: string | null;
  value_source?: string | null;
  is_missing?: boolean;
};
export type ComponentValidationResult = {
  component_id: string | string;
  is_valid: boolean;
  missing_fields_count: number;
  missing_fields?: {
    [key: string]: MissingFieldInfo;
  };
  template_fields?: ReadTemplateField[] | null;
  annotation_fields?: AnnotationFieldInfo[] | null;
  component_type?: ComponentType;
  order?: number | null;
};
export type PackageValidationResponse = {
  status: string;
  package_id: string | string;
  total_components: number;
  valid_components: number;
  components: ComponentValidationResult[];
  matter_context?: {
    [key: string]: string | null;
  };
};
export type RenderWorkflowResponse = {
  workflow_id: string;
  status: RenderStatus;
  package_id: string | string;
};
export type ErrorResponse = {
  error: string;
  details?: {
    [key: string]: string;
  } | null;
};
export type TreatmentRecordRequestRecordSchema = {
  id: string | string;
  created_at: string;
  modified_at: string;
  blob_id: string | string;
};
export type CreateTreatmentRecordRequestRecordSchema = {
  blob_id: string | string;
};
export type ResendReason =
  | "NO_RESPONSE_SLA_EXCEEDED"
  | "FAX_FAILED"
  | "PROVIDER_SAID_NOT_RECEIVED"
  | "MISSING_DOCS_OR_CORRECTED_FORM"
  | "WRONG_NUMBER_OR_INBOX"
  | "NOT_RIGHT_DEPARTMENT"
  | "PROVIDER_REJECTED_DESTINATION"
  | "OTHER";
export type ResendTreatmentRecordRequestSchema = {
  resend_reason: ResendReason;
  note?: string | null;
  new_destination_contact_point_id?: (string | string) | null;
};
export type ForkRetrySource =
  | "current_channel"
  | "channel"
  | "fax_transmission";
export type RetryTreatmentRecordRequestSchema = {
  /** How to select the contact information for the new request. */
  source?: ForkRetrySource;
  /** Specific historical channel to reuse when source is `channel`. */
  channel_id?: (string | string) | null;
  /** Historical fax transmission to reuse when source is `fax_transmission`. */
  fax_transmission_id?: (string | string) | null;
};
export type FollowupTriggeredResponse = {
  status: string;
};
export type SendFollowupSchema = {
  channel?: ("fax" | "email") | null;
  cover_message?: string | null;
  email_subject?: string | null;
  email_body?: string | null;
};
export type SubmitHipaaPackageSchema = {
  include_cheque?: boolean;
  cheque_amount?: string | null;
  cheque_memo?: string | null;
  cover_page_from?: string | null;
  cover_page_to?: string | null;
  cover_page_message?: string | null;
  channel_type?: TreatmentRecordRequestChannelType;
  mailing_class?: string | null;
  include_return_postage?: boolean | null;
  email_subject?: string | null;
  email_body?: string | null;
};
export type TransmissionStrategySchema = {
  enabled?: boolean;
  channel?: ("fax" | "email") | null;
  interval_days?: number;
  max_attempts?: number;
};
export const {
  useMattersHipaaAuthorizationCreateMutation,
  useMattersHipaaAuthorizationUpdateMutation,
  useMattersHipaaAuthorizationDestroyMutation,
  useMattersHipaaAuthorizationForMatterRetrieveQuery,
  useMattersHipaaAuthorizationRefreshCreateMutation,
  useMattersHipaaAuthorizationRemindCreateMutation,
  useMattersHipaaAuthorizationSendCreateMutation,
  useMattersHipaaAuthorizationStatusRetrieveQuery,
  useVoidHipaaAuthorizationMutation,
  useMattersProvidersRecordRequestsListQuery,
  useMattersProvidersRecordRequestsCreateMutation,
  useMattersProvidersRecordRequestsRetrieveQuery,
  useMattersProvidersRecordRequestsUpdateMutation,
  useMattersProvidersRecordRequestsDestroyMutation,
  useAcceptAlternateContactMutation,
  useMattersProvidersRecordRequestsAuditLogsListQuery,
  useMattersProvidersRecordRequestsAuditLogsCreateMutation,
  useMattersProvidersRecordRequestsAuditLogsRetrieveQuery,
  useMattersProvidersRecordRequestsAuditLogsUpdateMutation,
  useMattersProvidersRecordRequestsAuditLogsDestroyMutation,
  useMattersProvidersRecordRequestsChangeStatusCreateMutation,
  useMattersProvidersRecordRequestsChannelsListQuery,
  useMattersProvidersRecordRequestsChannelsCreateMutation,
  useMattersProvidersRecordRequestsChannelsRetrieveQuery,
  useMattersProvidersRecordRequestsChannelsUpdateMutation,
  useMattersProvidersRecordRequestsChannelsDestroyMutation,
  useGetFollowupHistoryQuery,
  useGetFollowupOutcomeQuery,
  useGetHipaaEmailTemplateQuery,
  useGetHipaaSubmissionStatusQuery,
  useMattersProvidersRecordRequestsInvoicesListQuery,
  useMattersProvidersRecordRequestsInvoicesCreateMutation,
  useMattersProvidersRecordRequestsInvoicesRetrieveQuery,
  useMattersProvidersRecordRequestsInvoicesUpdateMutation,
  useRequestHipaaPackageRetrieveQuery,
  useRequestPackageComponentListQuery,
  useRequestPackageComponentCreateMutation,
  useRequestPackageComponentRetrieveQuery,
  useRequestPackageComponentUpdateMutation,
  useRequestPackageComponentDeleteMutation,
  useRequestPackageComponentReorderMutation,
  useRequestPackageComponentSearchTemplatesQuery,
  useRequestPackageComponentValidateAllMutation,
  useRequestHipaaPackageRetrieve2Query,
  useRequestHipaaPackageCreateWithDefaultsMutation,
  useRequestHipaaPackagePublishMutation,
  useRequestHipaaPackageRenderMutation,
  useRequestHipaaPackageUploadMutation,
  useMattersProvidersRecordRequestsRecordsListQuery,
  useMattersProvidersRecordRequestsRecordsCreateMutation,
  useMattersProvidersRecordRequestsRecordsRetrieveQuery,
  useMattersProvidersRecordRequestsRecordsDestroyMutation,
  useResendRecordRequestMutation,
  useRetryExistingContactMutation,
  useSendFollowupTransmissionMutation,
  useMattersProvidersRecordRequestsSendBlandCallCreateMutation,
  useSubmitHipaaPackageMutation,
  useTransmissionStrategyQuery,
  useTransmissionStrategy2Mutation,
} = injectedRtkApi;
